<template>
	<div>
		<el-tooltip effect="dark" placement="right" popper-class="tip-class">
			<div slot="content">
				1、退单商品数量：退单详情页中的退货数量（注：只记录手动退单数量，不会记录自动退单数量，自动退单数量需在订单商品数量统计）<br/>
				2、已拒绝的退单不计入统计<br/>
				3、退单商品金额为营销活动优惠后的金额，即退单详情页中的小计<br/>
				4、退单中商品、客户属性为下单时记录的商品、客户属性，后续更改不会改变订单下单时记录；如退单时客户名称为张三，退单后修改为李四，此时报表记录为张三不会修改为李四
			</div>
			<img src="~/images/icon/tooltip-icon.png" style="margin-left: 10px;cursor:pointer">
		</el-tooltip>
	</div>
</template>
<script>
export default {
	name: 'IconTip',
	data () {
		return {
		}
	},
	created () {

	},
	methods: {

	}
}
</script>
<style lang="stylus" scoped>

</style>
